module.exports = __webpack_public_path__ + "img/investor-declaration.e700ebef.svg";